import React, { forwardRef } from 'react';

// Hooks
import { useSelector, useDispatch } from 'react-redux';

// Actions
import { closeSnackbar } from '~/redux/actions/snackbar-actions';

// Utils
import { MESSAGES } from '~/utils/message';

// MUI Components
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Slide from '@mui/material/Slide';
import { Typography, Box } from '@mui/material';

// Images
import { AlertCIcon, ErrorCIcon, RemoveNotificationCIcon, SuccessCIcon } from '~/assets/images';

// Styles
import './styles.scss';

const GlobalSnackbar = () => {
  const vertical = 'top';
  const horizontal = 'right';

  const dispatch = useDispatch();

  const open = useSelector((state) => state.snackbarReducers.snackbar.open);
  const status = useSelector((state) => state.snackbarReducers.snackbar.status);
  const heading = useSelector((state) => state.snackbarReducers.snackbar.heading);
  const message = useSelector((state) => state.snackbarReducers.snackbar.message);

  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const Transition = (props) => {
    return <Slide {...props} direction="left" />;
  };

  const close = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(closeSnackbar());
  };

  const getAlert = () => {
    if (status === 'success')
      return {
        color: '#ED5C2F',
        title: MESSAGES.SNACKBAR.SUCCESS_TITLE,
        icon: SuccessCIcon,
      };
    if (status === 'error')
      return {
        color: '#DC2626',
        title: MESSAGES.SNACKBAR.UNSUCCESSFUL_TITLE,
        icon: ErrorCIcon,
      };
    return {
      color: '#ED5C2F',
      title: MESSAGES.SNACKBAR.HEADING,
      icon: AlertCIcon,
    };
  };

  if (!open) return;

  return message !== null ? (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      open={open}
      autoHideDuration={5000}
      onClose={close}
      TransitionComponent={Transition}
    >
      <Alert
        onClose={close}
        severity={status}
        className="alertWrapper"
        sx={{
          backgroundColor: getAlert().color,
        }}
      >
        <img src={getAlert().icon} alt="alert" />
        <Box>
          <Typography variant="h4">{heading || getAlert().title}</Typography>
          <Typography>{message}</Typography>
        </Box>
        <img
          src={RemoveNotificationCIcon}
          onClick={close}
          alt="close"
          style={{
            cursor: 'pointer',
          }}
        />
      </Alert>
    </Snackbar>
  ) : (
    <></>
  );
};

export default GlobalSnackbar;
